import React from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Dashboardd from '../Pages/dashboard';
import Login from '../modules/login';
import Chatboat from '../Pages/chatboat';
import Committee from '../Pages/Committee';
import PlatformConfiguration from '../Components/Platform/PlatformConfiguration';
import Department from '../Pages/Department/Department';
import CommitteeTitle from '../Pages/Committee/CommitteeTitle';
import RequireAuth from './RequireAuth';

const router = createBrowserRouter([
  {
    path: '/',
    Component: Login,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/Board&Committee',
        Component: Committee,
      },
      {
        path: '/Chatbot',
        Component: Chatboat,
      },
      {
        path: '/governance',
        element: <PlatformConfiguration />,
      },
      {
        path: '/Department',
        element: <Department />,
      },
      {
        path: '/group-dashboard',
        element: <Committee />,
      },
    ],
  },
]);
const Router = () => {
  return <RouterProvider router={router} />;
};
export default Router;
